import React from 'react';
import { UserMinus, Clock, Package, BookOpen, MessageSquare, Shield } from 'lucide-react';

const OffboardingInsightsPanel = ({ data, exitReasons, detailed = false }) => {
  return (
    <div className="bg-card border border-border rounded-lg p-6">
      <div className="flex items-center justify-between mb-6">
        <div>
          <h2 className="text-xl font-bold text-foreground mb-1">Offboarding Insights</h2>
          <p className="text-sm text-muted-foreground">Exit process efficiency and knowledge transfer</p>
        </div>
        <div className="p-3 bg-orange-500/10 rounded-lg">
          <UserMinus className="w-6 h-6 text-orange-500" />
        </div>
      </div>

      {/* Key Metrics Grid */}
      <div className="grid grid-cols-2 md:grid-cols-3 gap-4 mb-6">
        <div className="p-4 bg-muted/50 rounded-lg">
          <div className="flex items-center gap-2 mb-2">
            <UserMinus className="w-4 h-4 text-muted-foreground" />
            <span className="text-xs text-muted-foreground">Total Exited</span>
          </div>
          <p className="text-2xl font-bold text-foreground">{data?.totalExited}</p>
        </div>
        <div className="p-4 bg-muted/50 rounded-lg">
          <div className="flex items-center gap-2 mb-2">
            <Clock className="w-4 h-4 text-muted-foreground" />
            <span className="text-xs text-muted-foreground">Avg Process Time</span>
          </div>
          <p className="text-2xl font-bold text-foreground">{data?.avgExitProcessTime}d</p>
        </div>
        <div className="p-4 bg-muted/50 rounded-lg">
          <div className="flex items-center gap-2 mb-2">
            <Package className="w-4 h-4 text-muted-foreground" />
            <span className="text-xs text-muted-foreground">Asset Recovery</span>
          </div>
          <p className="text-2xl font-bold text-foreground">{data?.assetRecoveryRate}%</p>
        </div>
      </div>

      {/* Detailed Metrics */}
      {detailed && (
        <div className="space-y-4 mb-6">
          <div className="flex items-center justify-between p-3 bg-muted/30 rounded-lg">
            <div className="flex items-center gap-3">
              <BookOpen className="w-5 h-5 text-purple-500" />
              <span className="text-sm font-medium text-foreground">Knowledge Transfer Score</span>
            </div>
            <span className="text-lg font-bold text-foreground">{data?.knowledgeTransferScore}%</span>
          </div>
          <div className="flex items-center justify-between p-3 bg-muted/30 rounded-lg">
            <div className="flex items-center gap-3">
              <MessageSquare className="w-5 h-5 text-blue-500" />
              <span className="text-sm font-medium text-foreground">Exit Interview Completion</span>
            </div>
            <span className="text-lg font-bold text-foreground">{data?.exitInterviewCompletion}%</span>
          </div>
          <div className="flex items-center justify-between p-3 bg-muted/30 rounded-lg">
            <div className="flex items-center gap-3">
              <Shield className="w-5 h-5 text-green-500" />
              <span className="text-sm font-medium text-foreground">Compliance Score</span>
            </div>
            <span className="text-lg font-bold text-foreground">{data?.complianceScore}%</span>
          </div>
        </div>
      )}

      {/* Exit Reasons */}
      {exitReasons && (
        <div>
          <h3 className="text-sm font-semibold text-foreground mb-3">Exit Reason Analysis</h3>
          <div className="space-y-3">
            {exitReasons?.map((reason, index) => (
              <div key={index} className="space-y-1">
                <div className="flex items-center justify-between text-sm">
                  <span className="text-foreground">{reason?.reason}</span>
                  <span className="font-medium text-foreground">{reason?.percentage}%</span>
                </div>
                <div className="w-full bg-muted rounded-full h-2">
                  <div
                    className="bg-orange-500 h-2 rounded-full transition-all"
                    style={{ width: `${reason?.percentage}%` }}
                  ></div>
                </div>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default OffboardingInsightsPanel;